import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const UTM_KEY = "okkio_utm";
// Cattura first-touch di UTM + referrer (solo hostname, no PII/query), persistiti per la sessione utente.
export const captureUtm = () => {
  try {
    const existing = JSON.parse(localStorage.getItem(UTM_KEY) || "null");
    if (existing) return existing;
    const p = new URLSearchParams(window.location.search);
    const data = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      const v = p.get(k);
      if (v) data[k] = String(v).slice(0, 120);
    });
    let ref = "";
    try { ref = document.referrer ? new URL(document.referrer).hostname : ""; } catch { /* ignore */ }
    if (ref) data.referrer = ref.slice(0, 120);
    if (Object.keys(data).length) { localStorage.setItem(UTM_KEY, JSON.stringify(data)); return data; }
    return {};
  } catch { return {}; }
};
export const getUtm = () => {
  try { return JSON.parse(localStorage.getItem(UTM_KEY) || "null") || {}; } catch { return {}; }
};

export const track = (event, props = {}) => {
  axios.post(`${API}/analytics/event`, { event, props: { ...getUtm(), ...props } }).catch(() => {});
};

export const fmtEuro = (n) => {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n);
};

export const riskMeta = {
  basso: { label: "Rischio basso", cls: "bg-[#16A36A]/10 text-[#16A36A] border-[#16A36A]/30", dot: "#16A36A" },
  medio: { label: "Rischio medio", cls: "bg-[#F59E0B]/10 text-[#B45309] border-[#F59E0B]/30", dot: "#F59E0B" },
  alto: { label: "Rischio alto", cls: "bg-[#DC3F4C]/10 text-[#DC3F4C] border-[#DC3F4C]/30", dot: "#DC3F4C" },
};

export const naturaMeta = {
  fatto: { label: "Fatto nel documento", cls: "bg-slate-100 text-slate-600" },
  inferenza: { label: "Inferenza AI", cls: "bg-[#3157F6]/10 text-[#3157F6]" },
  benchmark: { label: "Confronto benchmark", cls: "bg-[#0F172A]/5 text-[#0F172A]" },
};
